import React, { useState, useEffect ,useRef} from 'react';
import {
  Box, Container, Typography, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogActions,
  IconButton, Chip, Grid, CircularProgress, Paper, Divider, List, ListItem, ListItemIcon, ListItemText, Badge,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, ToggleButton, ToggleButtonGroup,
  TextField, InputAdornment, MenuItem, Select, FormControl, InputLabel,Collapse, Alert,Drawer,Stack,
} from '@mui/material';
import {
  Close as CloseIcon, LocalPharmacy as PillIcon, Person as UserIcon, Phone as PhoneIcon,
  LocationOn as MapPinIcon, CalendarToday as CalendarIcon, Notifications as BellIcon,
  Error as AlertCircleIcon, Inventory as PackageIcon, CheckCircle as CheckCircleIcon,
  Cancel as XCircleIcon, Schedule as ClockIcon, LocalShipping as TruckIcon,
  Description as DescriptionIcon, Download as DownloadIcon,
  ViewModule as ViewModuleIcon, TableChart as TableChartIcon, Phone, LocationOn,
  Search as SearchIcon, FilterList as FilterListIcon,  CallSplit as CallSplitIcon, CheckCircle,LocalShipping,Search,
  ExpandMore as ExpandMoreIcon, 
  ExpandLess as ExpandLessIcon ,
  Visibility,
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';
import PersonIcon from '@mui/icons-material/Person';
import CustomDialog from '../../CustomDialog';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { apiRequest } from '../../fetchSetup';
import axios from 'axios';
import Pagination from "@mui/material/Pagination";
import { orderAssignmentAPI } from "../DeliveyAgentScreens/deliveryAgentAPI";


const AssignAgent = ({selectedOrder,orderType,deliveryType,agentRole,onAssignmentSuccess}) => {
    const [agents, setAgents] = useState([]);
    const [assignDialog, setAssignDialog] = useState({
      open: false,
      item: null,
    });
    
    const [confirmDialog, setConfirmDialog] = useState({
      open: false,
      agent: null,
      item: null,
    });
    
    const [agentSearchQuery, setAgentSearchQuery] = useState('');
    
    const [assignLoading, setAssignLoading] = useState(false);
    const [notificationDialog, setNotificationDialog] = useState({
        open: false, type: 'success', title: '', message: ''
      });

useEffect(() => { fetchAgentData(); }, []);

    // ── Fetch diagnostic + agent data ─────────────────────────────────────────
    const fetchAgentData = async () => {
      try {
        const [agentsRes] = await Promise.all([
          orderAssignmentAPI.getActiveAgents(),
        ]);
        if (agentsRes.data.success) setAgents(agentsRes.data.data);
      } catch (error) {
        setNotificationDialog({
          open: true, type: 'error',
          title: 'Error Loading Data',
          message: error.response?.data?.message || error.message || 'Failed to load data.',
        });
      } finally {
        console.log("fghjk")
      }
    };
  
  const handleAssignAgent = async () => {
  try {
    setAssignLoading(true);

    const { item, agent } = confirmDialog;

    const response = await orderAssignmentAPI.assignAgent(item.id, orderType, agent.id, deliveryType);
      console.log(response)

    if (response.data.success) {

      setNotificationDialog({
          open: true, type: 'success', title: 'Success',
          message: `Agent ${agent.name} assigned.`,
        });
        if (onAssignmentSuccess) {
    onAssignmentSuccess(response.data,agent.agentId);
  }
      setConfirmDialog({
        open: false,
        agent: null,
        item: null,
      });

      setAssignDialog({
        open: false,
        item: null,
      });
      fetchAgentData();

    }

  } catch (error) {

    setNotificationDialog({
      open: true,
      type: 'error',
      title: 'Assignment Failed',
      message: error.message,
    });

  } finally {
    setAssignLoading(false);
  }
};

const getFilteredAgents = () => {
let filtered = agents.filter(
    (agent) => agent.agentRole === agentRole
  );
  if (agentSearchQuery.trim()) {
    const q = agentSearchQuery.toLowerCase();

    filtered = filtered.filter(agent =>
      agent.name?.toLowerCase().includes(q) ||
      agent.phone?.includes(q) ||
      agent.id?.toString().includes(q)
    );
  }

  return filtered;
};
const AgentList = ({ agents, onSelect }) => (
  agents.length === 0 ? (
    <Paper
      sx={{
        p: 3,
        bgcolor: '#fff3e0',
        border: '1px solid #ff9800',
        mt: 2
      }}
    >
      <Typography color="text.secondary">
        No available agents.
      </Typography>
    </Paper>
  ) : (
    <Box sx={{ mt: 2 }}>
      {agents.map(agent => (
        <Paper
          key={agent.id}
          sx={{
            p: 2,
            mb: 2,
            cursor: 'pointer',
            border: '2px solid transparent',
            '&:hover': {
              borderColor: '#006D77',
              bgcolor: '#f5f5f5',
            },
          }}
          onClick={() => onSelect(agent)}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography variant="body1" fontWeight={500}>
                {agent.name}
              </Typography>

              <Typography
                variant="caption"
                color="text.secondary"
              >
                {agent.phone}
              </Typography>

              <Box mt={1}>
                <Chip
                  label={agent.agentRole}
                  size="small"
                  color="primary"
                />

                <Chip
                  label={`${agent.currentOrders || 0}/${agent.maxOrderCapacity || 5}`}
                  size="small"
                  variant="outlined"
                  sx={{ ml: 1 }}
                />
              </Box>
            </Box>

            <CheckCircle
              sx={{
                color: '#006D77',
                fontSize: 28
              }}
            />
          </Box>
        </Paper>
      ))}
    </Box>
  )
);

  return (
    <div>
 <Paper variant="outlined" sx={{ p: 2 }}>

  { agentRole==='sample_collection' ? (<Typography variant="h6" fontWeight="bold" gutterBottom>
    Assign Sample Collection Agent
  </Typography>):(<Typography variant="h6" fontWeight="bold" gutterBottom>
    Assign Delivery Agent
  </Typography>)}


        <Button
  variant="contained"
  startIcon={<LocalShipping />}
  onClick={() => {
    setAgentSearchQuery('');
    setAssignDialog({
      open: true,
      item: selectedOrder,
    });
  }}
  sx={{
    bgcolor: '#006D77',
    '&:hover': {
      bgcolor: '#005A63',
    },
  }}
>
  Assign Agent
</Button>

</Paper>
<Dialog
  open={assignDialog.open}
  onClose={() =>
    setAssignDialog({
      open: false,
      item: null,
    })
  }
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>
    Assign Agent
  </DialogTitle>

  <DialogContent dividers>

    <TextField
      fullWidth
      placeholder="Search agent..."
      variant="outlined"
      size="small"
      value={agentSearchQuery}
      onChange={(e) =>
        setAgentSearchQuery(e.target.value)
      }
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
      sx={{ mb: 2 }}
    />

    <AgentList
      agents={getFilteredAgents()}
      onSelect={(agent) =>
        setConfirmDialog({
          open: true,
          agent,
          item: assignDialog.item,
        })
      }
    />

  </DialogContent>

  <DialogActions>
    <Button
      onClick={() =>
        setAssignDialog({
          open: false,
          item: null,
        })
      }
    >
      Cancel
    </Button>
  </DialogActions>
</Dialog>


<CustomDialog
  open={confirmDialog.open}
  type="warning"
  title="Confirm Assignment"
  message={`Assign ${confirmDialog.agent?.name || ''}?`}
  buttonText="Yes, Assign"
  secondaryButtonText="Cancel"
  onClose={handleAssignAgent}
  onSecondaryAction={() =>
    setConfirmDialog({
      open: false,
      agent: null,
      item: null,
    })
  }
  loading={assignLoading}
/>
 <CustomDialog
          open={notificationDialog.open}
          type={notificationDialog.type}
          title={notificationDialog.title}
          message={notificationDialog.message}
          buttonText="OK"
          onClose={() => setNotificationDialog({ ...notificationDialog, open: false })}
        />

</div>
  )    
}
export default AssignAgent;